export default __webpack_public_path__ + "static/media/Grant.0647a71e.png";